import React from "react";
import "./OurSolution.css";
import CodeHideOurSolution from "../../assets/ttgimage1.jpg";

function VårJobb() {
  return (
    <div className="ttg-1-container">
      <div className="ttg-1-content">
        <div className="ttg-1-text-container">
          <h1 className="ttg-1-main-title">Välkommen till Tak Till Golv!</h1>

          <p className="ttg-1-description-12">
            Vi är stolta över att vara din pålitliga partner inom
            totalentreprenad. Hos oss får du en helhetslösning för dina
            byggprojekt, oavsett om det är renoveringar, ombyggnationer eller
            nybyggnationer. Med vår expertis och erfarenhet tar vi hand om allt
            från planering och design till utförande och färdigställande. Du kan
            lita på oss för att leverera resultat av högsta kvalitet,
            skräddarsydda efter dina behov och önskemål.
            <br></br>
            <br></br>
            Vi erbjuder en komplett uppsättning tjänster för att göra ditt hem
            eller företag vackrare och mer funktionellt än någonsin tidigare.
            Vårt erfarna team av hantverkare och specialister är redo att ta sig
            an allt från att bygga strukturer från grunden till att lägga sista
            penseldraget på en färsk målning. Oavsett om det är renovering av
            ditt kök, badrum eller hela fastigheten, eller om det handlar om att
            förbättra golvytan för att passa din stil och livsstil, kan du lita
            på Tak Till Golv för en professionell och pålitlig service.
          </p>
        </div>

        <div className="ttg-1-Our-Solution-container">
          <img
            src={CodeHideOurSolution}
            alt="CodeHideOurSolution"
            className="ttg-1-Our-Solution"
          />
        </div>
      </div>
    </div>
  );
}

export default VårJobb;
